module.exports = __webpack_public_path__ + "img/xbc.3b478177.svg";